import Axios from "axios"

// const baseUrl = "https://api.zhengshangyun.cn";
const baseUrl = "http://api.zhengshangyun.cn";
// 封装axios.get方法
function getRequest(url, params, callback) {
  Axios({
    method: "get",
    url: baseUrl + url,
    params: params,
    timeout: 5000
  }).then((response) => {
    let result = response.data;
    if (result.Tag == 1) {
      if (callback) {
        callback(result);
      }
    } else {
      this.$dialog.alert({
        title: '提示',
        message: result.message,
      })
    }
  }).catch((error) => {
    console.log(error);
  })
}

export default {
  getRequest: getRequest,
  baseUrl: baseUrl
}


// WEBPACK FOOTER //
// ./src/utils/request.js